import React from 'react';

interface Props {
  isPositive: boolean;
}

export const RatingsTrendIcon: React.FC<Props> = ({ isPositive }) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    className={isPositive ? 'text-green' : 'rotate-180 text-primary'}
  >
    <path
      d="M4.0792 0.431787C4.58076 -0.170082 5.51517 -0.137713 5.97388 0.49742L9.26615 5.05595C9.8393 5.84954 9.27226 6.95854 8.29334 6.95854H1.20229C0.184888 6.95854 -0.370899 5.77191 0.280428 4.99031L4.0792 0.431787Z"
      fill="currentColor"
    />
  </svg>
);
